import React, { useState } from "react";
import styles from './partList.module.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button, Grid,
  Divider,

} from "@mui/material";
import { Address, Close, Contact, Copy, Customer, CustomerInfo, EmailBox, Payment, Phone, Refresh } from "../../../Svg";
import NestedUserHeader from "../../../component/reusable/NestedUserHeader";
import { styled } from '@mui/material/styles';
import { handleCopy } from "../../../utils/fomateDate";


const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));



const QuoteHistory = () => {
  const data = [
    { id: 1, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 2, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 3, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 4, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 5, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 6, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 7, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 8, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 9, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 10, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 11, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 12, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 13, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 14, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 15, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 16, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 17, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 18, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 19, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 20, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
  ];
  // Handle page navigation
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Calculate total number of pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Get the current items to display
  const currentItems = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };


  // Generate an array for page numbers
  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <>
      <NestedUserHeader
        index="Quotes History"
        root="Dashboard"
        buttonText={'Add Subcategory'}
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
            <Box sx={{ p: 2, }} display="flex" alignItems="center" >
              <CustomerInfo />
              <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                Customer Info
              </Typography>
            </Box>
            <Divider sx={{ mb: 1 }} />
            <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
              <Box display="flex" >
                <Customer />
                <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                  <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                    Customer:
                  </Typography>
                  <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                    Jay Hadgunson
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
              <Box display="flex" >
                <EmailBox />
                <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                  <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                    Email:
                  </Typography>
                  <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                    jay.hadgunson@mail.com
                  </Typography>
                </Box>
              </Box>
              <Box>
                <div>
                  <Copy />
                </div>
              </Box>
            </Box>
            <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
              <Box display="flex" >
                <Phone />
                <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                  <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                    Phone Number:
                  </Typography>
                  <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                    050 414 8788
                  </Typography>
                </Box>
              </Box>
              <Box>
                <div >
                  <Copy />
                </div>
              </Box>
            </Box>
            <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
              <Box display="flex" >
                <Address />
                <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                  <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                    Shipping Address:
                  </Typography>
                  <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                    Jay Hadgunson 1833  Bel Meadow Drive, Fontana, California 92335, USA
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Grid>

      </Grid>


      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
          <Box display="flex" alignItems="center" >
            <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
              10 Products
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
              Quoted date: 24 Sep 2024
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: '#00B789' }}>
              Accept & Sent
            </Typography>
          </Box>
        </Box>

        <div className={styles.previewContainer}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>Sl No</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture Part #</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Required Quantity</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>Price</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>MOQ</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id} className={styles.previewstripedRow}>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>{item.id}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item.partNumber}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item.quantity}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>

                    {item.manufacturer}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter"
                      className={styles.addCatInput}
                    />
                  </td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>
                    <div className={styles.closetd}>
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter"
                        className={styles.addCatInput}
                      />
                      <div style={{ display: "flex", gap: "20px", padding: '0px 20px' }}>
                        <Refresh /> <Close />
                      </div>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </Paper>


      <Grid container spacing={3} style={{marginTop:'20px'}}>
        <Grid item xs={12} md={12}>
          <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
            <Box sx={{ p: 2, }} display="flex" alignItems="center" >
              <CustomerInfo />
              <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
              User Info
              </Typography>
            </Box>
            <Divider sx={{ mb: 1 }} />
            <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
              <Box display="flex" >
                <Customer />
                <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                  <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                  User:
                  </Typography>
                  <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                  User name (Admin)
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Grid>

      </Grid>
      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
          <Box display="flex" alignItems="center" >
            <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
              10 Products
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
              Quoted date: 24 Sep 2024
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: '#00B789' }}>
              Accept & Sent
            </Typography>
          </Box>
        </Box>

        <div className={styles.previewContainer}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>Sl No</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture Part #</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Required Quantity</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>Price</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>MOQ</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id} className={styles.previewstripedRow}>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>{item.id}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item.partNumber}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item.quantity}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>

                    {item.manufacturer}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter"
                      className={styles.addCatInput}
                    />
                  </td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>
                    <div className={styles.closetd}>
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter"
                        className={styles.addCatInput}
                      />
                      <div style={{ display: "flex", gap: "20px", padding: '0px 20px' }}>
                        <Refresh /> <Close />
                      </div>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>


        </div>
      </Paper>
    </>
  );
};

export default QuoteHistory;
